<app-pias-layout>
  <div pias-layout-content>
    <div id="form-navigation-tab-container" class="container-fluid">
      <div id="form-navigation-tab-header" class="d-flex justify-content-between">
        <h5 class="page-header">DM Assessment</h5>
      </div>

      <div>
        <mat-card appearance="raised">
          <mat-card-content>
            <mat-tab-group #tabGroup [(selectedIndex)]="selectedIndex"
              (selectedTabChange)="__onAgentOnboardingTabChange($event)">

              @if(designation === 'Introducer - Individual'){
              <mat-tab label="Application" id="new-repapplication">
                <app-introducer-form-individual></app-introducer-form-individual>
              </mat-tab>
              }@else if(designation === 'Introducer - Corporate'){
              <mat-tab label="Application" id="new-repapplication">
                <app-introducer-form-corporate></app-introducer-form-corporate>
              </mat-tab>
              }@else{

              <mat-tab label="Application" id="new-repapplication">
                <app-new-rep-application></app-new-rep-application>
                @if(this.readonly() == false){
                <div class="form-actions mt-4">
                  <button mat-raised-button color="primary" class="save-btn" (click)="nextTab()"
                    [disabled]="selectedIndex === totalTabs - 1">
                    <span>Next</span>
                    <mat-icon>arrow_forward</mat-icon>
                  </button>
                </div>
                }
              </mat-tab>

              <mat-tab label="Checklist" id="new-repchecklist">
                <app-new-rep-checklist (next)="nextTab()"></app-new-rep-checklist>

              </mat-tab>

              <mat-tab label="DM Assessment" id="bdm-assessment">
                <app-bdm-assessment></app-bdm-assessment>
              </mat-tab>
              }
            </mat-tab-group>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <!-- <app-new-rep-application></app-new-rep-application>
        <app-rm-assessment></app-rm-assessment> -->
  </div>
</app-pias-layout>